// Copyright (c) Microsoft Corporation. All rights reserved.
export { default as config } from './config.json';
export const logitechAppId = '36102dd3-6953-45f6-8b48-031fb95e0e0d';
export const razerAppId = '0ed22b6f-b61d-41eb-810a-a1ed586a550b';
//# sourceMappingURL=constants.js.map